import React, { Fragment } from 'react';
import { add as addToCartService } from '../Services/Cart.service';
import withReactiveStyleBuyButton from './withReactiveStyleBuyButton';
import { receive, loadError, loadAddError } from '../Actions/Cart.action';
import { catchError } from '../Actions/Error.action';
import { useDispatch, useSelector } from 'react-redux';
import { translate } from '../Services/translation';
import { lensspecificationconstants } from '../lensspecificationconstants';

const BuyButton = ({
  label,
  articleNumber,
  quantityFieldId,
  href,
  cssClass,
  onClick,
    
  rightStrength,
  leftStrength,
  
  rightCurve,
  leftCurve,
                     
  rightDiameter,
  leftDiameter,
    
  rightCylinder,
  leftCylinder,
    
  rightAxis,
  leftAxis,

  rightEyeAdd,
  leftEyeAdd,

  rightColor,
  leftColor,
    
  rightPacket,
  leftPacket,
    
  rightCylinderHasOptions,
  leftCylinderHasOptions,
  
  rightAxisHasOptions,
  leftAxisHasOptions,
  
  rightAddHasOptions,
  leftAddHasOptions,
  rightColorHasOptions,
  leftColorHasOptions,

  excludeLeftValidations = false,
  excludeRightValidations = false,
  rightEyeProductNumber,
  leftEyeProductNumber,
  handleBuyButtonClick,
  subscription,
  subscriptionExistsForRightEye,
  subscriptionExistsForLeftEye,
  lensDurationCategory,
  clinicalPartActive,
}) => {
  return (
    <Fragment>
      {articleNumber ? (
        <a
          className={cssClass}
          onClick={(e) => {
            e.preventDefault();
            onClick({
              articleNumber,
              quantityFieldId,
              rightStrength,
              leftStrength,
              rightCurve,
              leftCurve,
              rightDiameter,
              leftDiameter,
              rightCylinder,
              leftCylinder,
              rightAxis,
              leftAxis,
              rightEyeAdd,
              leftEyeAdd,
              rightColor,
              leftColor,
              rightPacket,
              leftPacket,
              rightCylinderHasOptions,
              leftCylinderHasOptions,
              rightAxisHasOptions,
              leftAxisHasOptions,
              
              rightAddHasOptions,
              leftAddHasOptions,
              rightColorHasOptions,
              leftColorHasOptions,

              excludeLeftValidations,
              excludeRightValidations,
              rightEyeProductNumber,
              leftEyeProductNumber,
              handleBuyButtonClick,
              subscription,
              subscriptionExistsForRightEye,
              subscriptionExistsForLeftEye,
              lensDurationCategory,
              clinicalPartActive,
            });            
          }}
          href={href || '#'}
          rel="nofollow"
        >
          {label}
        </a>
      ) : (
        <a className={cssClass} href={href || '#'} rel="nofollow">
          {label}
        </a>
      )}
    </Fragment>
  );
};

const StyledButton = (props) => {
  const dispatch = useDispatch();
  const cartState = useSelector((state) => state.cart);
  const { setIsProcessing } = props;
  const onClick = async ({
    articleNumber,
    quantityFieldId,
    rightStrength,
    leftStrength,  
    rightCurve,
    leftCurve,  
    rightDiameter,
    leftDiameter,  
    rightCylinder,
    leftCylinder,  
    rightAxis,
    leftAxis,
    rightEyeAdd,
    leftEyeAdd,
    rightColor,
    leftColor,
    rightPacket,
    leftPacket,
    rightCylinderHasOptions,
    leftCylinderHasOptions,
    rightAxisHasOptions,
    leftAxisHasOptions,
    rightAddHasOptions,
    leftAddHasOptions,
    rightColorHasOptions,
    leftColorHasOptions,
    excludeLeftValidations = false,
    excludeRightValidations = false,
    rightEyeProductNumber,
    leftEyeProductNumber,
    subscription,    
    lensDurationCategory, 
    clinicalPartActive,   
  }) => {
    setIsProcessing(true); 
    try {
      const validateMessage = ValidateLensSpecification(
        rightStrength,
        leftStrength,
        rightCurve,
        leftCurve,
        rightDiameter,
        leftDiameter,
        rightCylinder,
        leftCylinder,
        rightAxis,
        leftAxis,
        rightEyeAdd,
        leftEyeAdd,
        rightColor,
        leftColor,
        rightPacket,
        leftPacket,
        rightCylinderHasOptions,
        leftCylinderHasOptions,
        rightAxisHasOptions,
        leftAxisHasOptions,
        rightAddHasOptions,
        leftAddHasOptions,
        rightColorHasOptions,
        leftColorHasOptions,
        excludeLeftValidations,
        excludeRightValidations,
        subscription,        
        lensDurationCategory,
        cartState,               
      );
      if (validateMessage && validateMessage.length > 0) {
        dispatch(loadAddError(validateMessage[0]));
        return false;
      } else {
        dispatch(loadAddError([]));
        // const quantity = quantityFieldId
        // ? document.getElementById(quantityFieldId).value
        // : 1;
        const quantityElement = document.getElementById(quantityFieldId);
        const quantity = quantityElement ? quantityElement.value : 1;
        const cart = await addToCartService({
          articleNumber,
          quantity,
          rightStrength,
          leftStrength,
          rightCurve,
          leftCurve,
          rightDiameter,
          leftDiameter,
          rightCylinder,
          leftCylinder,
          rightAxis,
          leftAxis,
          rightEyeAdd,
          leftEyeAdd,
          rightColor,
          leftColor,
          rightPacket,
          leftPacket,
          rightEyeProductNumber,
          leftEyeProductNumber,
          subscription,
          lensDurationCategory,
          clinicalPartActive,
        }).then(() => {
          props.handleIsProcessing();
          props.handleBuyButtonClick();
          dispatch(receive(cart));          
          return true;
        }).catch((ex) => {          
          if (ex.response) {      
            ex.response.text().then((error) => {     
              dispatch(loadAddError(error));
              return false;
            });
          }          
        });                
      }
    } catch (ex) {      
      dispatch(catchError(ex, (error) => loadError(error)));
      return false;
    }
    finally {
      setIsProcessing(false); 
    }
  };
  const Button = withReactiveStyleBuyButton(BuyButton, onClick, 'buy-button');
  return <Button {...props} />;
};

const ValidateLensSpecification = (
  rightStrength,
  leftStrength,
  rightCurve,
  leftCurve,
  rightDiameter,
  leftDiameter,
  rightCylinder,
  leftCylinder,
  rightAxis,
  leftAxis,
  rightEyeAdd,
  leftEyeAdd,
  rightColor,
  leftColor,
  rightPacket,
  leftPacket,
  rightCylinderHasOptions,
  leftCylinderHasOptions,
  rightAxisHasOptions,
  leftAxisHasOptions,
  rightAddHasOptions,
  leftAddHasOptions,
  rightColorHasOptions,
  leftColorHasOptions,
  excludeLeftValidations = false,
  excludeRightValidations = false,
  subscription, 
  lensDurationCategory,
  cartState,
) => {
  const errors = [];  

  if (subscription) {
    if (cartState.subscriptionExistsForRightEye && rightStrength !== '') {
      errors.push(`${translate('coptikk.product.subscriptionforeyeexists')} - ${translate('coptikk.product.righteye')}`);
    }

    if (cartState.subscriptionExistsForLeftEye && leftStrength !== '') {
      errors.push(`${translate('coptikk.product.subscriptionforeyeexists')} - ${translate('coptikk.product.lefteye')}`);
    }

    if ((cartState.subscriptionExistsForLeftEye || cartState.subscriptionExistsForRightEye) && 
    cartState.lensDurationCategoryExistingInCart && lensDurationCategory !== cartState.lensDurationCategoryExistingInCart) {
      errors.push(`${translate('coptikk.adminportal.subscription.lensdurationforproductsnotallowed')}`);
    }
  } else {
    if (cartState.subscriptionExistsForLeftEye || cartState.subscriptionExistsForRightEye) {
      errors.push(`${translate('coptikk.product.subscriptionforeyeexists')}`);
    }
  }

  if (
    (!excludeRightValidations && (rightStrength === '0' || !rightStrength) &&
    !rightCurve &&
    !rightDiameter &&
    !rightPacket) &&
    (!excludeLeftValidations && (leftStrength === '0' || !leftStrength) &&
    !leftCurve &&
    !leftDiameter &&
    !leftPacket)
  ) {
    errors.push(translate('coptikk.product.youmustselectfields'));
  }
  
  if (
    (!excludeRightValidations && (!rightStrength || rightStrength === '') && (rightPacket !== "" && rightPacket !== '0')) ||
    (!excludeLeftValidations && (!leftStrength || leftStrength === '') && (leftPacket !== "" && leftPacket !== '0'))
  ) {
    errors.push(translate('coptikk.product.youmustselectfields'));
  }

  if (!excludeRightValidations) {
    if (rightStrength && rightStrength !== '') {
      if (!rightCurve || rightCurve === '0') {
        errors.push(
          `${translate('coptikk.product.youmustselect')} ${translate(
            'coptikk.product.curve'
          )} - ${translate('coptikk.product.righteye')}`
        );
      }
  
      if (!rightDiameter || rightDiameter === '0') {
        errors.push(
          `${translate('coptikk.product.youmustselect')} ${translate(
            'coptikk.product.diameter'
          )} - ${translate('coptikk.product.righteye')}`
        );
      }
  
      if (rightCylinderHasOptions && (!rightCylinder || rightCylinder === '0')) {
        errors.push(
          `${translate('coptikk.product.youmustselect')} ${translate(
            'coptikk.product.cylinder'
          )} - ${translate('coptikk.product.righteye')}`
        );
      }
  
      if (rightAxisHasOptions && (!rightAxis || rightAxis === '0')) {
        errors.push(
          `${translate('coptikk.product.youmustselect')} ${translate(
            'coptikk.product.axis'
          )} - ${translate('coptikk.product.righteye')}`
        );
      }
  
      if (rightAddHasOptions && (!rightEyeAdd || rightEyeAdd === '0')) {
        errors.push(
          `${translate('coptikk.product.youmustselect')} ${translate(
            'coptikk.product.addfield'
          )} - ${translate('coptikk.product.righteye')}`
        );
      }
  
      if (rightColorHasOptions && (!rightColor || rightColor === '0')) {
        errors.push(
            `${translate('coptikk.product.youmustselect')} ${translate(
                'coptikk.product.color'
            )} - ${translate('coptikk.product.righteye')}`
        );
      }
      
      if (!rightPacket || rightPacket === '0') {
        errors.push(
          `${translate('coptikk.product.youmustselect')} ${translate(
            'coptikk.product.packets'
          )} - ${translate('coptikk.product.righteye')}`
        );
      }
    } 
  }  

  if(!excludeLeftValidations) {
    if (leftStrength && leftStrength !== '') {
      if (!leftCurve || leftCurve === '0') {
        errors.push(
          `${translate('coptikk.product.youmustselect')} ${translate(
            'coptikk.product.curve'
          )} - ${translate('coptikk.product.lefteye')}`
        );
      }
  
      if (!leftDiameter || leftDiameter === '0') {
        errors.push(
          `${translate('coptikk.product.youmustselect')} ${translate(
            'coptikk.product.diameter'
          )} - ${translate('coptikk.product.lefteye')}`
        );
      }
  
      if (leftCylinderHasOptions && (!leftCylinder || leftCylinder === '0')) {
        errors.push(
          `${translate('coptikk.product.youmustselect')} ${translate(
            'coptikk.product.cylinder'
          )} - ${translate('coptikk.product.lefteye')}`
        );
      }
  
      if (leftAxisHasOptions && (!leftAxis || leftAxis === '0')) {
        errors.push(
          `${translate('coptikk.product.youmustselect')} ${translate(
            'coptikk.product.axis'
          )} - ${translate('coptikk.product.lefteye')}`
        );
      }
  
      if (leftAddHasOptions && (!leftEyeAdd || leftEyeAdd === '0')) {
        errors.push(
            `${translate('coptikk.product.youmustselect')} ${translate(
                'coptikk.product.addfield'
            )} - ${translate('coptikk.product.lefteye')}`
        );
      }
  
      if (leftColorHasOptions && (!leftColor || leftColor === '0')) {
        errors.push(
            `${translate('coptikk.product.youmustselect')} ${translate(
                'coptikk.product.color'
            )} - ${translate('coptikk.product.lefteye')}`
        );
      }
      
      if (!leftPacket || leftPacket === '0') {
        errors.push(
          `${translate('coptikk.product.youmustselect')} ${translate(
            'coptikk.product.packets'
          )} - ${translate('coptikk.product.lefteye')}`
        );
      }
    }
  }  

  return errors;
};

export default StyledButton;